import { render, staticRenderFns } from "./productShortcut(old).vue?vue&type=template&id=632061c1&scoped=true&"
import script from "./productShortcut(old).vue?vue&type=script&lang=js&"
export * from "./productShortcut(old).vue?vue&type=script&lang=js&"
import style0 from "./productShortcut(old).vue?vue&type=style&index=0&id=632061c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632061c1",
  null
  
)

export default component.exports